import { useEffect } from 'react';
import type { Socket } from 'socket.io-client';

export const useInitSocket = (
  socket: Socket,
  meta: { id: string; userId?: string; accessToken: string | null }
) => {
  useEffect(() => {
    if (!meta.userId) {
      socket.disconnect();
      return;
    }

    if (!socket.active) {
      socket.io.opts.extraHeaders = {
        authorization: `Bearer ${meta.accessToken}`,
      };
      socket.connect();
    }

    socket.on('connect', () => {
      console.info(`Socket '${meta.id}' — connected!`);
    });
    socket.on('disconnect', () => {
      console.info(`Socket '${meta.id}' — disconnected!`);
    });

    return () => {
      socket.disconnect();
      socket.off('connect');
      socket.off('disconnect');
    };
  }, [meta.userId]);
};
